module.exports = __webpack_public_path__ + "img/logout.2a446c15.svg";